import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const sendEvent = httpsCallable(functions, 'logWebsiteEvent');

function sessionID() {
  const key = 'leavenow_analytics_session';
  try {
    const existing = window.localStorage.getItem(key);
    if (existing) return existing;
    const created = window.crypto?.randomUUID?.().replaceAll('-', '')
      || `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(key, created);
    return created;
  } catch {
    return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
  }
}

function acquisition() {
  const parameters = new URLSearchParams(window.location.search);
  let referrer = 'direct';
  try {
    if (document.referrer) referrer = new URL(document.referrer).hostname.replace(/^www\./, '') || 'direct';
  } catch { /* Malformed referrers never interrupt the website. */ }
  return {
    source: parameters.get('utm_source') || referrer,
    campaign: parameters.get('utm_campaign') || 'none'
  };
}

export function trackWebsiteEvent(event, properties = {}) {
  const path = window.location.pathname || '/';
  if (path === '/internal' || path === '/operations') return Promise.resolve();
  const { source, campaign } = acquisition();
  return sendEvent({ event, properties, path, source, campaign, sessionID: sessionID() }).catch(() => undefined);
}
